import {  Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CustomSpinnerComponent } from '@core/components/ui-custom-spinner/custom-spinner.component';

@Component({
  selector: 'ui-clinng-button',
  standalone: true,
  imports: [CommonModule,MatButtonModule,MatProgressSpinnerModule,CustomSpinnerComponent],
  templateUrl: './ui-clinng-button.component.html',
  styleUrl: './ui-clinng-button.component.scss',
})
export class UiClinngButtonComponent {
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Output() onClick = new EventEmitter<void>();

  click() {
    this.onClick.emit();
  }
  
}
